// extracted by mini-css-extract-plugin
module.exports = {"form-footer":"FormFooter_form-footer__2GA9r","cancel-btn":"FormFooter_cancel-btn__vFUdv","submit-btn":"FormFooter_submit-btn__31C0y"};